import { render, staticRenderFns } from "./slidebar.vue?vue&type=template&id=32711e24&"
import script from "./slidebar.vue?vue&type=script&lang=js&"
export * from "./slidebar.vue?vue&type=script&lang=js&"
import style0 from "./slidebar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports